import { BaseNamespace } from 'stores/BaseNamespace';
import { QualificationStore } from './stores/QualificationStore';
import { InitialAccountSetupStore } from './stores/InitialAccountSetupStore';

export class OnboardingNamespace extends BaseNamespace {
  public qualification = new QualificationStore(this.rootStore);
  public initialAccountSetup = new InitialAccountSetupStore(this.rootStore);
}
